import { buttonIconSlot, buttonIconSvg, buttonRecipe } from "./button.styles.js";
import { c } from "react/compiler-runtime";
import { jsx, jsxs } from "react/jsx-runtime";
import { clsx } from "clsx";
import { Button as Button$1 } from "@base-ui/react/button";
//#region src/components/button/button.tsx
var resolveButtonIntent = (kind, intent) => {
	if (kind !== "primary") return "neutral";
	return intent ?? "neutral";
};
/**
* Button is the primary action control for user-triggered workflows,
* designed around kind and intent semantics. Use `kind="text"` for
* link-like actions that do not navigate.
*/
var Button = (t0) => {
	const $ = c(23);
	let children;
	let icon;
	let intent;
	let otherProps;
	let t1;
	let t2;
	let t3;
	let unsafeClassName;
	if ($[0] !== t0) {
		({children, icon, intent, unsafeClassName, kind: t1, disabled: t2, type: t3, ...otherProps} = t0);
		$[0] = t0;
		$[1] = children;
		$[2] = icon;
		$[3] = intent;
		$[4] = otherProps;
		$[5] = t1;
		$[6] = t2;
		$[7] = t3;
		$[8] = unsafeClassName;
	} else {
		children = $[1];
		icon = $[2];
		intent = $[3];
		otherProps = $[4];
		t1 = $[5];
		t2 = $[6];
		t3 = $[7];
		unsafeClassName = $[8];
	}
	const kind = t1 === void 0 ? "primary" : t1;
	const disabled = t2 === void 0 ? false : t2;
	const type = t3 === void 0 ? "button" : t3;
	const Icon = icon;
	let t4;
	if ($[9] !== disabled || $[10] !== intent || $[11] !== kind || $[12] !== unsafeClassName) {
		t4 = clsx(buttonRecipe({
			kind,
			intent: resolveButtonIntent(kind, intent),
			disabled
		}), unsafeClassName);
		$[9] = disabled;
		$[10] = intent;
		$[11] = kind;
		$[12] = unsafeClassName;
		$[13] = t4;
	} else t4 = $[13];
	let t5;
	if ($[14] !== Icon) {
		t5 = Icon ? /* @__PURE__ */ jsx("span", {
			"aria-hidden": "true",
			className: buttonIconSlot,
			children: /* @__PURE__ */ jsx(Icon, {
				"aria-hidden": "true",
				focusable: "false",
				className: buttonIconSvg
			})
		}) : void 0;
		$[14] = Icon;
		$[15] = t5;
	} else t5 = $[15];
	let t6;
	if ($[16] !== children || $[17] !== disabled || $[18] !== otherProps || $[19] !== t4 || $[20] !== t5 || $[21] !== type) {
		t6 = /* @__PURE__ */ jsxs(Button$1, {
			type,
			disabled,
			...otherProps,
			className: t4,
			children: [t5, children]
		});
		$[16] = children;
		$[17] = disabled;
		$[18] = otherProps;
		$[19] = t4;
		$[20] = t5;
		$[21] = type;
		$[22] = t6;
	} else t6 = $[22];
	return t6;
};
//#endregion
export { Button };
